import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Confirm } from 'semantic-ui-react';

export const useConfirmPopup = () => {
  const [promise, setPromise] = useState(null);
  const [dialogProps, setDialogProps] = useState({});

  useEffect(() => {
    renderElement();
  }, [promise, dialogProps]);

  const closeHandler = () => {
    setPromise(null);
    setDialogProps({});
    };

  const confirmHandler = () => {
    promise?.resolve(true);
    dialogProps.onConfirm?.();
    closeHandler();
  };

  const cancelHandler = () => {
    promise?.resolve(false);
    dialogProps.onCancel?.();
    closeHandler();
  };

  const cleanProps = { ...dialogProps };
  ['onCancel', 'onConfirm'].forEach((funcName) =>
    Reflect.deleteProperty(cleanProps, funcName)
  );
  /*Removal of the methods as we had already used those inside confirm/cancel handlers
   and we do not want to overwrite the native ones when we spread them on <Confirm/> */

  // eslint-disable-next-line react/prop-types
  const ConfirmationDialog = () => (
    <Confirm
      open={promise}
      dimmer='inverted'
      confirmButton={{ content: 'Yes', positive: true }}
      cancelButton={{ content: 'No', negative: true }}
      onCancel={cancelHandler}
      onConfirm={confirmHandler}
      {...cleanProps}
    />
  );

  const renderElement = () => {
    var element = document.getElementById('confirmationContainer');
    if (!element) {
      element = document.createElement('div');
      element.setAttribute('id', 'confirmationContainer');
      document.body.appendChild(element);
    }
    ReactDOM.render(
      <ConfirmationDialog
        dialogProps={dialogProps}
        resolve={promise?.resolve}
      />,
      element
    );
  };

  const confirm = (dialogProps) => {
    setDialogProps(dialogProps);

    return new Promise((resolve) => {
      setPromise({ resolve });
    });
  };

  return { confirm };
};
